module.exports = __webpack_public_path__ + "94034b244f2f6fe947a30bd104b1bf3b.pdf";